module.exports = __webpack_public_path__ + "static/media/wuerchahushan3.ea111fbf.jpg";